import Circle from 'classes/Circle';

class DrawableCircle extends Circle {
  draw = context => {
    const fillStyle = context.fillStyle;

    context.beginPath();
    context.fillStyle = this.color;
    context.arc(this.centerX, this.centerY, this.radius, 0, 2 * Math.PI);
    context.fill();

    context.closePath();

    context.fillStyle = fillStyle;
  };
}

export default DrawableCircle;



// WEBPACK FOOTER //
// ./src/classes/DrawableCircle/index.js